import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppServiceManager } from "common/services/appServiceManager";
import { BreadcrumbService } from "app/breadcrumb.service";
import { ButtonModule } from "primeng/button";
import { INotification } from "../../shared/Domains/notifications";
import { HttpClient } from "@angular/common/http";
import { Configuration } from "config/config";
import { IUser } from "app/shared/Domains/IUser";
import { AuthService } from "common/services/auth.service";
import { IMemberType } from "app/shared/Domains/memberType";
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: "app-notification",
    templateUrl: "./notification.component.html",
    styleUrls: ["./notification.component.css"],
})
export class NotificationComponent implements OnInit {
    NotificationId: any;
    sendingList: IMemberType[];
    Notification: INotification;
    checked1: boolean = false;
    loading: boolean;
    user: IUser;
    mode: string;
  constructor(
    private LanguageService: LanguageService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private _http: HttpClient,
    private config: Configuration,
    private appServiceManager: AppServiceManager,
    private breadcrumbService: BreadcrumbService
    ) {
        route.params.subscribe((params) => {
            this.NotificationId = params["id"];
        });
        this.sendingList = [
          {memberType: 'In Active'},
          {memberType: 'Freezed'},
          {memberType: 'Active'},
      ];
        this.breadcrumbService.setItems([
            { label: "Notifications Management" },
            { label: "All Notifications", routerLink: ["/notifications"] },
            { label: "Notification" },
        ]);
    }
    setLabel(label) {
      return this.LanguageService.GetCurrentLanguage("NotificationComponent", label);
    }
    ngOnInit() {
      this.InitObjects();
        this.user = AuthService.getLoggedInUser();
        this.loading = false;
        if(this.NotificationId){
          this.mode = 'edit';
          this.getNotificationById();
        }else {
          this.mode = 'add';
        }
        setTimeout(() => {
          let element = document.getElementsByClassName("pi-th-large")[0] as HTMLElement;
          element.click();
        }, 100);
    }

    InitObjects(){
      this.Notification = new INotification();
    }

    // GET NOTIFICATION BY ID
    getNotificationById() {
      this.appServiceManager.get("notificationCenter/" + this.NotificationId).subscribe((res: any) => {
        if (res) {
          this.Notification = res;
          // this.Trainer = res.TrainerData;
          this.Notification.scheduleDate = this.Notification.scheduleDate
              ? new Date(this.Notification.scheduleDate)
              : null;
          this.breadcrumbService.setItems([
            { label: 'Notification Management' },
            { label: 'All Notifications', routerLink: '/notifications' },
            { label: this.Notification.title }
          ]);
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
    save() {
        this.confirmationService.confirm({
          message: "Are you sure you want to save this notification ?",
          accept: () => {
            this.Notification.company = AuthService.getLoggedInCompany();
            this.Notification.branch = AuthService.getLoggedInBranch();
            this.Notification.createdBy = AuthService.getLoggedInUserId();
            this.Notification.status = "Pending";
            this.appServiceManager.post('notificationCenter/', this.Notification).subscribe((res: any) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Notification Successfully Created" });
              this.router.navigateByUrl('/notifications');
            }, (error) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
          }
        });
    }

    update() {
      this.confirmationService.confirm({
        message: "Are you sure you want to update notification ?",
        accept: () => {
          this.Notification.modifiedBy = AuthService.getLoggedInUserId();
          this.appServiceManager.put("notificationCenter/" + this.Notification._id, this.Notification).subscribe((res: any) => {
            this.getNotificationById();
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Notification Successfully Updated' });
          },
            (error) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
      });
    }

}
